var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { attrs: { id: "toast_footer" } }, [
    _vm.showSiteMap
      ? _c("div", { staticClass: "sitemap_wrap", style: _vm.footerStyle }, [
          _c(
            "div",
            { staticClass: "inner" },
            [
              _c(
                "router-link-ex",
                {
                  staticClass: "logo_toast",
                  attrs: {
                    to: _vm.countryPath,
                    domain: _vm.getDomain("homepage")
                  }
                },
                [
                  _c("img", {
                    class: _vm.siteMapLogoClass,
                    attrs: { src: _vm.siteMapLogo, alt: "NHN Cloud" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "lst_sns" },
                _vm._l(_vm.footer.snsList, function(sns, i) {
                  return _c("li", { key: i, staticClass: "item_sns" }, [
                    _c(
                      "a",
                      {
                        staticClass: "link_sns",
                        class: sns.class,
                        attrs: { href: sns.link, target: "_blank" }
                      },
                      [_vm._v(_vm._s(sns.text))]
                    )
                  ])
                })
              ),
              _vm._v(" "),
              _c("gnb-footer-site-map")
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "nhn_footer", style: _vm.footerStyle }, [
      _c("div", { staticClass: "inner" }, [
        _c("em", { staticClass: "logo_nhn" }, [
          _c(
            "a",
            {
              staticClass: "logo_link",
              attrs: { href: _vm.footer.logoUrl, target: "_blank" }
            },
            [
              _c("img", {
                attrs: { src: _vm.footer.logoImg, alt: "NHN JAPAN" }
              })
            ]
          )
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "notice_txt is_m_show",
          domProps: { innerHTML: _vm._s(_vm.footer.exemptionNotice) }
        }),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "lst_company_link" },
          _vm._l(_vm.footer.links, function(link, i) {
            return _c("li", { key: i, staticClass: "item_link" }, [
              link.isPopup
                ? _c("a", {
                    staticClass: "link_txt",
                    attrs: { href: "javascript:;", target: "_blank" },
                    domProps: { innerHTML: _vm._s(link.text) },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.openPopup(link.url, 665, 720, "privacy-policy")
                      }
                    }
                  })
                : _c("a", {
                    staticClass: "link_txt",
                    attrs: { href: link.url, target: "_blank" },
                    domProps: { innerHTML: _vm._s(link.text) }
                  })
            ])
          })
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.hideFamilySite,
                expression: "hideFamilySite"
              }
            ],
            staticClass: "family_site_wrap",
            class: { is_active: _vm.familySite.active }
          },
          [
            _c(
              "button",
              {
                staticClass: "btn_family_site",
                on: { click: _vm.toggleFamilySite }
              },
              [_c("span", { staticClass: "btn_txt" }, [_vm._v("Family site")])]
            ),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "lst_family_site",
                on: { click: _vm.hideFamilySite }
              },
              _vm._l(_vm.footer.familySites, function(site, i) {
                return _c("li", { key: i, staticClass: "site_item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link_txt",
                      attrs: { href: site.link, target: "_blank" }
                    },
                    [_vm._v(_vm._s(site.text))]
                  )
                ])
              })
            )
          ]
        ),
        _vm._v(" "),
        _c("p", {
          staticClass: "notice_txt is_pc_show",
          domProps: { innerHTML: _vm._s(_vm.footer.exemptionNotice) }
        }),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "lst_company_info" },
          _vm._l(_vm.footer.companyInfo, function(companyInfo, i) {
            return _c("li", {
              key: i,
              staticClass: "info_item",
              domProps: { innerHTML: _vm._s(companyInfo.text) }
            })
          })
        ),
        _vm._v(" "),
        _c("p", { staticClass: "copyright_txt" }, [
          _vm._v(_vm._s(_vm.footer.copyright))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }